export interface CreatePreSignedUrlRequest {
  original_name: string;
}

export interface CreatePreSignedUrlResponse {
  upload_url: string;
  file_path: string;
  id: string;
}

export enum FileType {
  CUSTOM = "custom",
  ORGANIZATION_LOGO = "organization-logo",
  SUPPLIER_AGREEMENT = "supplier-agreement",
}

export enum FileExtension {
  JPG = "jpg",
  PNG = "png",
  PDF = "pdf",
  DOC = "doc",
  DOCX = "docx",
  ZIP = "zip",
  MP3 = "mp3",
  MP4 = "mp4",
  WEBM = "webm",
  PPT = "ppt",
  PPTX = "pptx",
  SVG = "svg",
  JPEG = "jpeg",
  CSV = "csv",
  XLS = "xls",
  XLSX = "xlsx",
}

export const getFileExtension = (filename: string): FileExtension | null => {
  const extension = filename.split(".").pop()?.toLowerCase();
  if (extension && Object.values(FileExtension).includes(extension as FileExtension)) {
    return extension as FileExtension;
  }
  return null;
};
